import { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

// Permissions
import {
    canViewAnyStepModel, canViewStepModel, canCreateStepModel, canUpdateStepModel,
    canViewAnyRoadmapModel, canViewRoadmapModel, canCreateRoadmapModel, canUpdateRoadmapModel,
    canViewAnySheetModel, canViewSheetModel, canCreateSheetModel, canUpdateSheetModel,
    canViewAnySheetModelPlanification, canViewSheetModelPlanification, canCreateSheetModelPlanification, canUpdateSheetModelPlanification,
} from 'permissions';
import { DocumentTitleRoute, RequirePerm } from '../index';

/* * *
* Lazy Imports
*/

const Models = lazy(() => import('../../../views/authenticated/models'));

// Step Models
const StepModels = lazy(() => import('../../../views/authenticated/models/step-models'));
const StepModel = lazy(() => import('../../../views/authenticated/models/step-models/step-model'));
const CreateStepModel = lazy(() => import('../../../views/authenticated/models/step-models/create-step-model'));
const UpdateStepModel = lazy(() => import('../../../views/authenticated/models/step-models/update-step-model'));

// Roadmap Models
const RoadmapModels = lazy(() => import('../../../views/authenticated/models/roadmap-models'));
const RoadmapModel = lazy(() => import('../../../views/authenticated/models/roadmap-models/roadmap-model'));
const CreateRoadmapModel = lazy(() => import('../../../views/authenticated/models/roadmap-models/create-roadmap-model'));
const UpdateRoadmapModel = lazy(() => import('../../../views/authenticated/models/roadmap-models/update-roadmap-model'));

// Sheet Models
const SheetModels = lazy(() => import('../../../views/authenticated/models/sheet-models'));
const SheetModel = lazy(() => import('../../../views/authenticated/models/sheet-models/sheet-model'));
const CreateSheetModel = lazy(() => import('../../../views/authenticated/models/sheet-models/create-sheet-model'));
const UpdateSheetModel = lazy(() => import('../../../views/authenticated/models/sheet-models/update-sheet-model'));

// Sheet Model Planifications
const SheetModelPlanifications = lazy(() => import('../../../views/authenticated/models/sheet-model-planifications'));
const SheetModelPlanification = lazy(() => import('../../../views/authenticated/models/sheet-model-planifications/sheet-model-planification'));
const CreateSheetModelPlanification = lazy(() => import('../../../views/authenticated/models/sheet-model-planifications/create-sheet-model-planification'));
const UpdateSheetModelPlanification = lazy(() => import('../../../views/authenticated/models/sheet-model-planifications/update-sheet-model-planification'));

// ---------------------------------------------------------------------------------------------------- \\
// ----------------------------------------- MODEL ROUTES --------------------------------------------- \\
// ---------------------------------------------------------------------------------------------------- \\

export default function ModelRoutes() {
    return (
        <Routes>
            <Route index element={<Models />} />
            <Route path="step-models">
                <Route index element={<RequirePerm perm={canViewAnyStepModel()}><StepModels /></RequirePerm>} />
                <Route path="create" element={<RequirePerm perm={canCreateStepModel()}><CreateStepModel /></RequirePerm>} />
                <Route path=":id" element={<DocumentTitleRoute title="step_model" id="id" />}>
                    <Route index element={<RequirePerm perm={canViewStepModel()}><StepModel /></RequirePerm>} />
                    <Route path="update" element={<RequirePerm perm={canUpdateStepModel()}><UpdateStepModel /></RequirePerm>} />
                </Route>
            </Route>
            <Route path="roadmap-models">
                <Route index element={<RequirePerm perm={canViewAnyRoadmapModel()}><RoadmapModels /></RequirePerm>} />
                <Route path="create" element={<RequirePerm perm={canCreateRoadmapModel()}><CreateRoadmapModel /></RequirePerm>} />
                <Route path=":id" element={<DocumentTitleRoute title="roadmap_model" id="id" />}>
                    <Route index element={<RequirePerm perm={canViewRoadmapModel()}><RoadmapModel /></RequirePerm>} />
                    <Route path="update" element={<RequirePerm perm={canUpdateRoadmapModel()}><UpdateRoadmapModel /></RequirePerm>} />
                </Route>
            </Route>
            <Route path="sheet-models">
                <Route index element={<RequirePerm perm={canViewAnySheetModel()}><SheetModels /></RequirePerm>} />
                <Route path="create" element={<RequirePerm perm={canCreateSheetModel()}><CreateSheetModel /></RequirePerm>} />
                <Route path=":id" element={<DocumentTitleRoute title="sheet_model" id="id" />}>
                    <Route index element={<RequirePerm perm={canViewSheetModel()}><SheetModel /></RequirePerm>} />
                    <Route path="update" element={<RequirePerm perm={canUpdateSheetModel()}><UpdateSheetModel /></RequirePerm>} />
                </Route>
            </Route>
            <Route path="sheet-model-planifications">
                <Route index element={<RequirePerm perm={canViewAnySheetModelPlanification()}><SheetModelPlanifications /></RequirePerm>} />
                <Route path="create" element={<RequirePerm perm={canCreateSheetModelPlanification()}><CreateSheetModelPlanification /></RequirePerm>} />
                <Route path=":id" element={<DocumentTitleRoute title="sheet_model_planifications" id="id" />}>
                    <Route index element={<RequirePerm perm={canViewSheetModelPlanification()}><SheetModelPlanification /></RequirePerm>} />
                    <Route path="update" element={<RequirePerm perm={canUpdateSheetModelPlanification()}><UpdateSheetModelPlanification /></RequirePerm>} />
                </Route>
            </Route>
        </Routes>
    );
}
